import { ApiUserQuota } from 'sprites-types/api/user-quota'

export const hasEnoughCredits = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }

  return userQuota.credits === 'unlimited' || userQuota.credits > 0
}

// Keep backward compatibility aliases
export const hasEnoughEditCredits = hasEnoughCredits
export const hasEnoughExecuteCredits = hasEnoughCredits

export const hasInfiniteCredits = (userQuota: ApiUserQuota | undefined): boolean => {
  if (!userQuota) {
    return false
  }
  return userQuota.credits === 'unlimited'
}

// Keep backward compatibility aliases
export const hasInfiniteEditCredits = hasInfiniteCredits
export const hasInfiniteExecuteCredits = hasInfiniteCredits

export const nextTierName = (userQuota: ApiUserQuota | undefined): string => {
  if (!userQuota) {
    return 'Build'
  }
  if (userQuota.subscription.name === 'Free') return 'Build'
  if (userQuota.subscription.name === 'Pro') return 'Build'
  if (userQuota.subscription.name === 'Build') return 'Launch'
  return 'Grow'
}

export const nextTierId = (userQuota: ApiUserQuota | undefined): string => {
  if (!userQuota) {
    return 'launch'
  }
  if (userQuota.subscription.name === 'Free') return 'launch'
  if (userQuota.subscription.name === 'Pro') return 'launch'
  if (userQuota.subscription.name === 'Build') return 'launch_new'
  return 'grow'
}
